import { formatDate } from "../../../ui library/helpers/functions";

const formatTimeDisplay = (timeString = "") => {
  if (!timeString) {
    return "";
  }

  const [hourStr, minuteStr] = timeString.split(":");
  let hour = parseInt(hourStr, 10);
  const minute = minuteStr;
  const ampm = hour >= 12 ? "pm" : "am";
  hour = hour % 12 || 12;
  return `${hour}:${minute} ${ampm}`;
};

export const formatAppointments = (appointments = []) => {
  return appointments.map(
    ({
      id,
      appointment_date,
      appointment_time,
      administered_services = [],
      associated,
      provider_type,
    }) => {
      const totalAmount = administered_services.reduce(
        (sum, service) => sum + Number(service?.price || 0),
        0
      );
      const amount = `$${totalAmount.toFixed(2)}`;

      const date = formatDate(appointment_date, "MM/dd/yyyy");
      const time = formatTimeDisplay(appointment_time);

      return {
        id,
        date,
        time,
        amount,
        associated,
        provider_type,
      };
    }
  );
};
